import {
    ADAPTIVE_MODE,
} from '../constants';

export function getZoom(manualAdaptiveMode: ADAPTIVE_MODE | null): string | null {
    switch (manualAdaptiveMode) {
        case ADAPTIVE_MODE.MOBILE: {
            return '1.7';
        }
        case ADAPTIVE_MODE.DESKTOP: {
            return '0.3';
        }
        case null: {
            return null;
        }
    }
}
